export const FEATURE_FLAG_EXPERIMENT_COOKIE_NAME = 'x-flag-exp'
export const FEATURE_FLAG_INTERNAL_COOKIE_NAME = 'x-flag-internal'

export const flags = {
  FLAG_EXPEDITED_SHIPPING_DISABLED:
    'my-pga-com-jrl-expedited-shipping-disabled',
  FLAG_FEAT_GROUP_EVENT_RECURRING_PAYMENTS_ENABLED:
    'my-pga-com-feat-group-event-recurring-payments-enabled',
  FLAG_STUDENT_REVENUE_STAT: 'my-pga-com-student-revenue-statistic',
  FLAG_REFUND_QUICK_ACTION: 'my-pga-com-refund-quick-action',
  FLAG_APP_INSTALL_BANNER_AD: 'my-pga-com-app-install-banner-ad',
  FLAG_FEAT_COACHING_CENTER_STUDENT_LIST_MENU_MANAGEMENT:
    'my-pga-com-student-list-management-visibility',
  FLAG_FEAT_HOME_AWAY_EVENTS: 'my-pga-com-home-away-events',
  FLAG_FEAT_ENFORCE_FCC: 'my-pga-com-enforce-fcc-preselect',
  FLAG_FEAT_BYPASS_JRL_REG: 'my-pga-com-jrl-registration-date-bypass',
  FLAG_FEAT_STREAM_THREADS: 'mobile-and-my-pga-com-stream-threads',
  FLAG_FEAT_COACH_BUSINESS_INSIGHTS: 'my-pga-com-coach-business-insights',
  FLAG_FEAT_LESSON_PACK_GIFTING: 'my-pga-com-lesson-pack-gifting',
  FLAG_FEAT_CC_MEMBER_BAY_RESERVATIONS: 'my-pga-com-cc-member-bay-reservations',
  FLAG_FEAT_CONTACT_WEBCAL: 'my-pga-com-feat-contact-webcal',
  FLAG_FEAT_KIT_ORDER_APPROVAL: 'my-pga-com-feat-jrl-kit-order-approval',
  FLAG_FEAT_COACH_ANALYTICS: 'my-pga-com-feat-coach-analytics',
  FLAG_FEAT_COACH_ENDORSEMENTS: 'my-pga-com-coach-endorsements',
  FLAG_FEAT_LEAD_AGE_AND_MESSAGING: 'my-pga-com-lead-age-and-messaging',
  FLAG_FEAT_COACH_LEAD_AUTO_REPLY: 'my-pga-com-coach-lead-auto-reply',
  FLAG_FEAT_PUT_LEADS_IN_LEFT_NAV: 'my-pga-com-put-leads-in-left-nav',
}
